import api from '../../../services/Api';
import { IAuditoriaPlIntegridadeResultado } from '../interfaces/IAuditoriaPlIntegridade';

export const AuditoriaPlIntegridadeService = {
  buscarResultado: async (params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaPlIntegridadeResultado> => {
    const { data } = await api.get<IAuditoriaPlIntegridadeResultado>(
      'auditoria-pl-integridade/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return data;
  },
};
